"use client";

import React from "react";
import { CircleCheck, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Service() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const bulletPoints = ["Knippen & Styling — Voor een coupe die perfect bij u past", "Kleurspecialismen — Van Balayage tot volledige kleuring", "Luxe Treatments — Intensieve verzorging voor gezond haar"];
  return <section data-section-id="132929" id="onze-expertise" className="bg-background py-24 md:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-96 h-96 bg-primary/10 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={leftRef} className={`relative transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative rounded-lg overflow-hidden border border-border bg-card shadow-xl">
              <div className="absolute inset-0 bg-gradient-to-tr from-secondary/5 to-transparent mix-blend-overlay" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/knippen_expertise.png" alt="High-fashion kapsel sessie bij VIP Company" className="w-full h-auto object-cover aspect-square md:aspect-[4/3] lg:aspect-square" />
            </div>
            {}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-primary/20 rounded-full blur-2xl" />
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-10 transition-all duration-1000 ease-out delay-200 ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight text-foreground">
                Onze Expertise
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl leading-relaxed">
                Van een tijdloze snit tot een gedurfde kleurtransformatie: ons team van experts staat klaar om uw natuurlijke schoonheid te accentueren met hoogwaardige technieken en persoonlijke aandacht.
              </p>
            </div>

            <ul className="space-y-6">
              {bulletPoints.map((point, i) => <li key={i} data-index={i} className="flex items-start gap-5">
                  <div className="mt-1 bg-primary/20 p-1.5 rounded-full shrink-0">
                    <CircleCheck className="size-5 text-primary" />
                  </div>
                  <span className="text-foreground text-lg font-medium leading-relaxed">
                    {point}
                  </span>
                </li>)}
            </ul>

            <div className="pt-6">
              <Button size="lg" className="rounded-lg px-10 h-14 text-base font-medium tracking-widest uppercase bg-primary text-primary-foreground shadow-md hover:bg-primary/90 transition-all">
                <MessageCircle className="mr-3 size-5" />
                BOEK NU
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}